import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: (props: any) => ({
      display: "flex",
      height: 64,
      flexDirection: "row",
      padding: 0,
      position: "relative",
      transition: "all 1s ease",
      backgroundColor: theme.colors.background,
      "&.custom-background *": {
        backgroundColor: `#${props?.appBarTheme?.background}`,
      },
      "&.custom-text *": {
        color: `#${props?.appBarTheme?.text}`,
      },
    }),
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "0px 32px",
      width: 240,
      overflow: "hidden",
    },
    firmAsLogo: {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    logo: {
      width: "auto",
      height: 36,
    },
    main: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    titleContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "0px 32px",
    },
    loadingIndicator: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: 2,
    },
    title: {
      ...theme.fonts.caption,
      color: theme.colors.textDefault,
    },
    familyMemberName: {
      ...theme.fonts.h6,
      color: theme.colors.action,
      cursor: "pointer",
    },
    proposalName: {
      ...theme.fonts.h4,
      color: theme.colors.textSubtle,
    },
    infoContainer: {
      display: "flex",
      flexDirection: "row",
      paddingRight: 45,
      alignItems: "center",
    },
    closeButton: {
      fontSize: 16,
      color: theme.colors.action,
      cursor: "pointer",
    },
    checkbox: {
      fontSize: 14,
      color: theme.colors.positive,
    },
    savedMessage: {
      marginLeft: 4,
      marginRight: 21,
      ...theme.fonts.caption,
      color: theme.colors.textSubtle,
    },
    headingContainer: {
      display: "flex",
    },
    boltIcon: {
      color: theme.colors.action,
      fontSize: 24,
    },
    headingText: {
      paddingLeft: 8,
      ...theme.fonts.h4,
    },
    proposalOverview: {
      padding: 0,
      ...theme.fonts.h3,
    },
    overviewContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    infoIcon: {
      cursor: "pointer",
      color: theme.colors.action,
      fontSize: 14,
      marginLeft: 5,
    },
    popoverText: {
      ...theme.fonts.h5,
    },
    closeIcon: {
      cursor: "pointer",
      marginLeft: 14,
    },
    "@media print": {
      titleContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 0,
      },
      main: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
